import React from "react";
interface LogoProps {
  showTagline?: boolean;
  size?: "md" | "lg";
}
export function Logo({
  showTagline = false,
  size = "md"
}: LogoProps) {
  const lg = size === "lg";
  return <span className="inline-flex flex-col leading-none" data-id="element-346" data-mp="3q9uu4v5knpwa">
      <span className={`font-display font-extrabold lowercase tracking-tight text-white ${lg ? "text-6xl" : "text-[26px]"}`} style={{
      textShadow: lg ? "4px 4px 0 #FFD400" : "2px 2px 0 #FFD400"
    }} data-id="element-347" data-mp="3qbe8gg7o3qvf">
        rise upp
      </span>
      {showTagline && <span className={`mt-1.5 font-medium tracking-[0.18em] text-brand ${lg ? "text-sm" : "text-[10px]"}`} data-id="element-348" data-mp="rqmi90jclnij">
          Awaken the passion
        </span>}
    </span>;
}